import { NormalizedCacheObject, ApolloClient as ApolloClientType } from '@apollo/client';
import ApolloClient from '.';

export type ContainerType = {
  apolloClient: ApolloClientType<NormalizedCacheObject>;
};

export const container: ContainerType = {
  apolloClient: ApolloClient(),
};
